import { render, staticRenderFns } from "./BigRegistrationButton.vue?vue&type=template&id=219af140&"
import script from "./BigRegistrationButton.vue?vue&type=script&lang=js&"
export * from "./BigRegistrationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports